import httpRequest, { httpAnonymousRequest } from 'httpRequest'
import { AuthModel, LoginContract } from 'models'
import { RefreshToken } from 'types/storeTypes'
import cookies from 'utilities/cookie'

const AUTH_PREFIX = '/auth'

const authService = {
    register: (username: string, password: string) =>
        httpRequest.post(
            `${AUTH_PREFIX}/register`,
            {},
            { params: { username, password } },
        ),
    login: (payload: LoginContract) =>
        httpAnonymousRequest.post<AuthModel>(`${AUTH_PREFIX}/login`, payload),
    logout: () => httpRequest.post(`${AUTH_PREFIX}/logout`),
    loginPin(pinCode: string) {
        return httpRequest.post<AuthModel>(
            '/auth/login/pin',
            JSON.stringify({
                previousRefreshToken: cookies.get(RefreshToken),
                pinCode,
            }),
        )
    },
    logoutAllByUsername: (payload: LoginContract) =>
        httpRequest.post(`${AUTH_PREFIX}/logout-all-terminals`, payload),
    logoutAllByPin: (pinCode: string) =>
        httpRequest.post<AuthModel>(
            `${AUTH_PREFIX}/logout-all-terminals/pin`,
            JSON.stringify(pinCode),
        ),
    refreshToken: (accessToken: string, refreshToken: string) =>
        httpAnonymousRequest.post<AuthModel>(`${AUTH_PREFIX}/refresh-token`, {
            accessToken,
            refreshToken,
        }),
    checkNonClientToken: () =>
        httpRequest.get(`${AUTH_PREFIX}/check-non-client-token`),
    issueRealAccessToken({ forceLogout }: { forceLogout: boolean }) {
        if (forceLogout)
            return httpRequest.post<AuthModel>(
                `${AUTH_PREFIX}/issue-real-access-token?forceLogout=true`,
                null,
            )

        return httpRequest.post<AuthModel>(
            `${AUTH_PREFIX}/issue-real-access-token`,
            null,
        )
    },
    checkToken: () => httpRequest.get(`${AUTH_PREFIX}/check-token`),
}

export default authService
